import defaultBreakpointConfig from '../constants/mediaBreakPoint.json'
import { configResponsiveHook } from '../hooks/useDevice'

let breakpointConfig = defaultBreakpointConfig
let responsive = {
  xs: false,
  sm: false,
  md: false,
  lg: false,
}
let listening = false
const subscribers = new Set()

// 响应式宽度计算
const calculate =  () => {
  const width = window.innerWidth
  const newInfo = {}
  let shouldUpdate = false
  for (const key of Object.keys(breakpointConfig)) {
    newInfo[key] = width >= breakpointConfig[key]
    if (newInfo[key] !== responsive[key]) {
      shouldUpdate = true
    }
  }
  if (shouldUpdate) {
    responsive = newInfo
  }
}

// resize监听
const handleResize = () => {
  const oldInfo = responsive
  calculate()
  if (oldInfo === responsive) return
  for (const subscriber of subscribers) {
    subscriber()
  }
}

// 配置响应式断点信息
const configResponsive = (config) => {
  breakpointConfig = config
  configResponsiveHook(config)
}

// 响应式监听及尺寸更新 TODO: resize事件注销
// window.removeEventListener('resize', handleResize)
const startResponsiveListener = () => {
  // if (!isBrowser) return
  if (!listening) {
    responsive = {}
    calculate()
    window.addEventListener('resize', handleResize)
    listening = true
  }
  calculate()
}


export {
  startResponsiveListener,
  configResponsive,
}
